import propsCoins from '../../assets/img/props_coins.png';
import { Spacer } from '../../components/Spacer/Spacer';
import useQuery from '../../utils/useQuery';
import styles from './RedirectToProps.module.css';

export const RedirectToProps = () => {
  const query = useQuery();

  const firstName = query.get('firstName');
  const lastName = query.get('lastName');
  const email = query.get('email');

  const PROPS_CODE = 'HKPROPS';

  let redirectLink = `https://web.propspoints.com/registration?code=${PROPS_CODE}`;

  if (firstName != null) {
    redirectLink += `&firstName=${firstName}`;
  }
  if (lastName != null) {
    redirectLink += `&lastName=${lastName}`;
  }
  if (email != null) {
    redirectLink += `&email=${email}`;
  }

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.imgContainer}>
          <img src={propsCoins} alt="props-coins" className={styles.img} />
        </div>
      </div>
      <div className={styles.right}>
        <Spacer height={64} />
        <h2 className={styles.bold}>
          Huoneistokeskuksen Oma Koti palvelu toimii nyt osana Propsia.
        </h2>
        <Spacer height={32} />
        <p className={styles.bodyRegular}>
          Props on suomalainen palvelu, joka palkitsee kuluttajia kaikista
          ostoista, täysin automaattisesti ja turvallisesti. Kuluttaja saa
          Propsin käyttöön yhdistämällä maksukortin palveluun ja sen käyttäminen
          on ilmaista. Props rekisteröi automaattisesti kaikki ostosi ja
          palkitsee kaikista ostoksista pisteinä.
        </p>
        <Spacer height={8} />
        <p className={styles.bodyRegular}>
          Ostojen rekisteröityminen sekä etujen käyttö ei edellytä sinulta
          erillistä etukorttia tai muuta tunnistetta. Suomalaisena palveluna
          Props on luotettava ja kuluttajan asialla. Propsin käyttö on sinulle
          ilmaista, emmekä koskaan luovuta tietojasi kolmannen osapuolen
          käyttöön.
        </p>
        <Spacer height={32} />
        <h3 className={styles.bold}>
          Liittymisedut Huoneistokeskuksen asiakkaalle
        </h3>
        <Spacer height={32} />
        <p className={styles.bodyRegular}>
          • 500 Props-pistettä liittymisbonuksena, kun rekisteröidyt
          käyttäjäksi.
        </p>
        <Spacer height={8} />
        <p className={styles.bodyRegular}>
          • Lisäksi Oma Kodin eksklusiiviset asumisen ja sisustamisen edut
          pysyvät sinulle muuttumattomina kuuden kuukauden ajan
        </p>
        <Spacer height={32} />
        <h3 className={styles.bold}>
          Miten liityn uudistettuun Huoneistokeskun Oma Koti palveluun
          Propsissa?
        </h3>
        <Spacer height={32} />
        <p className={styles.bodyRegular}>
          1. Käytä uutta kutsukoodiasi HKPROPS ja siirry rekisteröitymiseen
          allaolevasta linkistä
        </p>
        <Spacer height={8} />
        <p className={styles.bodyRegular}>2. Yhdistä maksukorttisi palveluun</p>
        <Spacer height={8} />
        <p className={styles.bodyRegular}>
          3. Ansaitse Props-pisteitä kaikista ostoksista automaattisesti ilman
          kanta-asiakaskorttia tai muuta tunnistetta
        </p>
        <Spacer height={8} />
        <p className={styles.bodyRegular}>
          4. Käytä Props-pisteitä johtavien brändien etuihin ja tarjouksiin
          Props Storessa
        </p>
        <Spacer height={32} />
        <p className={styles.bodyRegular}>Henkilökohtainen koodisi: HKPROPS</p>
        <Spacer height={64} />

        <a className={styles.buttonText} href={redirectLink}>
          Jatka rekisteröitymiseen
        </a>

        <Spacer height={64} />

        <h3 className={styles.bold}>
          Miten toimin, jos minulla on jo käyttäjätili Oma Koti -palveluun?
        </h3>
        <Spacer height={32} />
        <p className={styles.bodyRegular}>
          Vanha käyttäjätilisi on yhdistetty automaattisesti uuteen Props Oma
          Koti -palveluun. Olet myös saanut 500 Props-pistettä
          liittymisbonuksena.
        </p>
        <Spacer height={8} />
        <p className={styles.bodyRegular}>
          Pääseet kirjautumaan uuteen palveluun vanhalla käyttäjätunnuksellasi
          alla olevasta linkistä.
        </p>
        <Spacer height={64} />

        <a className={styles.buttonText} href="https://web.propspoints.com">
          Kirjaudu palveluun
        </a>

        <Spacer height={64} />
      </div>
    </div>
  );
};
